import { FaqAskQuestionFormData } from 'mk2/apps/faq/components/FaqAskQuestionForm';
import { APIFailureAction, APIRequestAction, APISuccessAction } from 'mk2/helpers/action';
import { NormalizedResponse } from 'mk2/helpers/api';

/////////////////////////////////////////////////////////////////////
// FAQ Ask Question Fetch

export const FAQ_ASK_QUESTION_FETCH_TRIGGER = 'FAQ_ASK_QUESTION_FETCH_TRIGGER';
export interface FaqAskQuestionFetchTriggerAction {
    readonly type: typeof FAQ_ASK_QUESTION_FETCH_TRIGGER;
    readonly faqId: string;
}
export const FAQ_ASK_QUESTION_FETCH_REQUEST = 'FAQ_ASK_QUESTION_FETCH_REQUEST';
export interface FaqAskQuestionFetchRequestAction extends APIRequestAction {
    readonly type: typeof FAQ_ASK_QUESTION_FETCH_REQUEST;
    readonly faqId: string;
}
export interface FaqAskQuestionFetchNormalizedResponse extends NormalizedResponse {
    readonly result: {
        prefillText: string;
        question: string;
    };
}
export const FAQ_ASK_QUESTION_FETCH_SUCCESS = 'FAQ_ASK_QUESTION_FETCH_SUCCESS';
export interface FaqAskQuestionFetchSuccessAction extends APISuccessAction<FaqAskQuestionFetchNormalizedResponse> {
    readonly type: typeof FAQ_ASK_QUESTION_FETCH_SUCCESS;
    readonly faqId: string;
}
export const FAQ_ASK_QUESTION_FETCH_FAILURE = 'FAQ_ASK_QUESTION_FETCH_FAILURE';
export interface FaqAskQuestionFetchFailureAction extends APIFailureAction {
    readonly type: typeof FAQ_ASK_QUESTION_FETCH_FAILURE;
    readonly faqId: string;
}

export const faqAskQuestionFetchTrigger =
    (faqId: string): FaqAskQuestionFetchTriggerAction => ({
        type: FAQ_ASK_QUESTION_FETCH_TRIGGER, faqId,
    });
export const faqAskQuestionFetchApi = {
    request: (faqId: string): FaqAskQuestionFetchRequestAction => ({
        type: FAQ_ASK_QUESTION_FETCH_REQUEST, faqId,
    }),
    success: (faqId: string, response: FaqAskQuestionFetchNormalizedResponse): FaqAskQuestionFetchSuccessAction => ({
        type: FAQ_ASK_QUESTION_FETCH_SUCCESS, faqId, response,
    }),
    failure: (faqId: string, error: any): FaqAskQuestionFetchFailureAction => ({
        type: FAQ_ASK_QUESTION_FETCH_FAILURE, faqId, error,
    }),
};

/////////////////////////////////////////////////////////////////////
// FAQ Ask Question Send

export const FAQ_ASK_QUESTION_SEND_TRIGGER = 'FAQ_ASK_QUESTION_SEND_TRIGGER';
export interface FaqAskQuestionSendTriggerAction {
    readonly type: typeof FAQ_ASK_QUESTION_SEND_TRIGGER;
    readonly faqId: string;
    readonly questionFd: FaqAskQuestionFormData;
}
export const FAQ_ASK_QUESTION_SEND_REQUEST = 'FAQ_ASK_QUESTION_SEND_REQUEST';
export interface FaqAskQuestionSendRequestAction extends APIRequestAction {
    readonly type: typeof FAQ_ASK_QUESTION_SEND_REQUEST;
    readonly faqId: string;
    readonly questionFd: FaqAskQuestionFormData;
}
export interface FaqAskQuestionSendNormalizedResponse extends NormalizedResponse {
    readonly result: {};
}
export const FAQ_ASK_QUESTION_SEND_SUCCESS = 'FAQ_ASK_QUESTION_SEND_SUCCESS';
export interface FaqAskQuestionSendSuccessAction extends APISuccessAction<FaqAskQuestionSendNormalizedResponse> {
    readonly type: typeof FAQ_ASK_QUESTION_SEND_SUCCESS;
    readonly faqId: string;
    readonly questionFd: FaqAskQuestionFormData;
}
export const FAQ_ASK_QUESTION_SEND_FAILURE = 'FAQ_ASK_QUESTION_SEND_FAILURE';
export interface FaqAskQuestionSendFailureAction extends APIFailureAction {
    readonly type: typeof FAQ_ASK_QUESTION_SEND_FAILURE;
    readonly faqId: string;
    readonly questionFd: FaqAskQuestionFormData;
}

export const faqAskQuestionSendTrigger =
    (faqId: string, questionFd: FaqAskQuestionFormData): FaqAskQuestionSendTriggerAction => ({
        type: FAQ_ASK_QUESTION_SEND_TRIGGER, faqId, questionFd,
    });
export const faqAskQuestionSendApi = {
    request: (faqId: string, questionFd: FaqAskQuestionFormData): FaqAskQuestionSendRequestAction => ({
        type: FAQ_ASK_QUESTION_SEND_REQUEST, faqId, questionFd,
    }),
    success: (faqId: string, questionFd: FaqAskQuestionFormData, response: FaqAskQuestionSendNormalizedResponse): FaqAskQuestionSendSuccessAction => ({
        type: FAQ_ASK_QUESTION_SEND_SUCCESS, faqId, questionFd, response,
    }),
    failure: (faqId: string, questionFd: FaqAskQuestionFormData, error: any): FaqAskQuestionSendFailureAction => ({
        type: FAQ_ASK_QUESTION_SEND_FAILURE, faqId, questionFd, error,
    }),
};
